import { Component, Input} from '@angular/core'; 
import { ProvidersService } from 'fccore2';
import { FcComponent } from '../fc';
/**
 * fc-layoutrowä¸ä¸å¸å±
 * 
 * ä¸ä¸å¸å±ç»ä»¶ã
 * 
 * éè¦ä¸ä¸å¸å±æ¶å¯åä¸ºä¸¤è¡æç§æ¯ä¾åã
 * 
 */
@Component({
    selector: 'fc-layoutrow',
    template: `
    <div class="fc-layoutrow"  [ngClass]="{fcClass:fcClass!==undefined}"   >
        <div class="fc-layoutrowcell fc-layoutrowcell1" [style.height]="_span" [style.minHeight]="_span">
            <ng-content select="[fccontent1]" style="height:100%;"></ng-content>
        </div>
        <div class="fc-layoutrowcell fc-layoutrowcell2">
            <ng-content select="[fccontent2]"></ng-content>
        </div>
    </div>
    `,
    styles: [`
    .fc-layoutrow{
        width:100%;
        height:100%;
        display:-webkit-flex;
	    display:flex;
        flex-flow:column;
        background-color:#ffffff;
    }
    .fc-layoutrowcell{
        width:100%;
    }
    .fc-layoutrowcell1{
       
    }
    .fc-layoutrowcell2{
        flex:1;
        overflow:hidden;
    }
    `],
})
export class FclayoutrowComponent extends FcComponent {
     /**è®¾ç½®fccontent1çé«åº¦,  åfccontent2ä¸ºå©ä½é«åº¦*/
    @Input()
    fcSpan: number = 46;
     /**é«åº¦*/
    _span: string;
    constructor(public provider: ProvidersService) {
        super(provider,'fc-layoutrow');
        this._span = this.fcSpan + 'px';
    }
    ngOnChanges(param): void {
        super.ngOnChanges(param);
        this._span = this.fcSpan + 'px';
    }
} 